import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';

export const tagFilterOption = (option: any, searchText: string): boolean => {
  if (!searchText) {
    return true;
  }
  const search = searchText.toLowerCase();
  if (option.data.value === EMPTY_FILTER_VALUE) {
    return String(option.data.label?.props?.children ?? '')
      .toLowerCase()
      .includes(search);
  }
  const tagName = String(option.data.label?.props?.tag?.name ?? '').toLowerCase();
  return tagName.includes(search);
};
